<div class="polaris-choice-list" [ngClass]="'polaris-choice-list--' + variant">
  @for (choice of choices; track choice.title; let choiceIndex = $index) {
    <label
      class="polaris-choice"
      [class.polaris-choice--selected]="choice.selected"
      (click)="choiceSelected.emit(choiceIndex)">
      <span class="polaris-choice__radio" [class.polaris-choice__radio--checked]="choice.selected"></span>
      <span class="polaris-choice__text">
        <span class="polaris-choice__title">{{ choice.title }}</span>
        @if (choice.description) {
          <span class="polaris-choice__description">{{ choice.description }}</span>
        }
      </span>
      @if (choice.trailing) {
        <span class="polaris-choice__trailing">{{ choice.trailing }}</span>
      }
    </label>
  }
</div>
